export const UiConstants = {
  // Default page size for paginated components
  // Keep in sync with backend: com.ul.sis.companion.core.PagedResult
  DEFAULT_PAGE_SIZE: 10,
} as const;
